var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91683 13.4999L4.66683 14.8333L6.25016 17.6665C6.41683 17.9999 6.66683 18.1666 7.00016 18.2499C7.3335 18.3333 7.66683 18.3332 8.00016 18.0832C8.16683 17.9999 8.25016 17.9166 8.41683 17.75C8.50016 17.5833 8.5835 17.4165 8.66683 17.2499C8.75016 17.0832 8.75016 16.9166 8.66683 16.7499C8.66683 16.5832 8.58349 16.4166 8.50016 16.2499L6.91683 13.4999ZM6.91683 13.4999L14.6668 11.7499C14.9168 11.6666 15.0835 11.5833 15.2502 11.5C15.4168 11.3333 15.5835 11.1665 15.6668 10.9999C15.7502 10.8332 15.7502 10.5833 15.7502 10.3333C15.7502 10.0833 15.6668 9.91657 15.5835 9.66657L11.8335 2.91659C11.7502 2.74992 11.5835 2.58327 11.4168 2.41661C11.2502 2.33327 11.0002 2.2499 10.8335 2.16657C10.5835 2.16657 10.4168 2.16654 10.1668 2.24988C10.0002 2.33321 9.75016 2.49988 9.66683 2.66654L4.41683 8.83323L6.91683 13.4999ZM16.0002 4.91661L18.4168 3.49988M14.5002 2.24988L15.5002 0.833252M17.5002 7.58323L19.1668 7.33329M2.0835 10.1665L4.33349 8.83323L6.91683 13.4166L4.66683 14.7499C4.3335 14.9165 4.0835 14.9999 3.75016 15.0832C3.41683 15.1666 3.0835 15.0833 2.75017 14.9999C2.41683 14.9166 2.08349 14.7499 1.83349 14.4999C1.58349 14.2499 1.3335 13.9999 1.16683 13.6666C0.833498 13.0833 0.750162 12.3333 0.916829 11.6666C1.0835 10.9999 1.50016 10.5832 2.0835 10.1665Z",
    stroke: "#414446",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/Campaigns.fa79e23dfdefbba71490696e5237bdfa.svg";
export { ForwardRef as ReactComponent };